export default {
  feedback: {
    success: 'Aplikacja mobilna została pomyślnie zapisana',
    error: 'Nie udało się zapisać aplikacji mobilnej',
  },
};
